import S from '@/settings'

export const CONTEXT_DOCUMENTS_ORGANIZATIONS = [S.QALEA_ORGANIZATION_NAME, S.ACME_ORGANIZATION_NAME]

export const EMBAT_ORGANIZATION_ID = 27

export const CONTEXT_DOCUMENTS_ORGANIZATION_IDS = [EMBAT_ORGANIZATION_ID]
